// data test
export const SYSTEM_ADMIN_TABS = "system-admin-tabs";
export const RESERVED_LICENSES_BUTTON = "reserved-licenses-button";
export const RENAME_WORKSPACES_BUTTON = "rename-workspace-button";
export const DELETE_WORKSPACE_BUTTON = "delete-workspace-button";
export const CONFIGURE_BANNER_WORKSPACE_BUTTON = "configure-banner-workspace-button";
export const SET_BANNER_BUTTON = "set-banner-button";
export const ACCORDION = "accordion";
export const USERNAME = "username";
export const WORKSPACES = "workspaces";
export const FILTER_ALL = "all";
export const FILTER_LICENSED = "licensed-users";
export const FILTER_MEMBERS = "members";
export const FILTER_NON_MEMBERS = "non-members";
export const FILTER_SYSTEM_ADMINS = "system-admins";

// attributes
export const ACTIVE = "active";

// actions
export const FETCH_WORKSPACES = "fetchWorkspaces";

// reducers
